import React, { useEffect, useRef, useState, useMemo } from 'react';
import ReactToPrint from 'react-to-print';
import {
  Form,
  Grid,
  Input,
  Button,
  TextArea,
  Message,
  Select,
  Icon,
  Checkbox,
} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import { ComponentsPropsI } from './types';
import FileUpload from '../../../features/MediaAssets/Details/FileUpload';
import PhotoUpload from '../../../features/MediaAssets/Details/PhotoUpload';
import DynamicRowsComponent from './DynamicRowsComponent';
import { useStore } from '../../stores/store';
import { Link } from 'react-router-dom';
import './styles.css';
import moment from 'moment';
import { GetCurrentUser } from '../../models/user';
import LoadingComponent from '../../layout/LoadingComponent';

function Components(props: ComponentsPropsI) {
 
  const {
    disabled,
    masterOptions,
    usersOptions,
    unfocusHandler,
    errorMessage,
    mastersHandler,
    usersHandler,
    getUploadedFiles,
    onPhotoClick,
    onChangeHandler,
    saveDynamicTableData,
    // camImage,
    elementDetails,
    index,
    // addPhotographsHandler,
    // classNameFunc,
    subTaskIdNo,
    subTaskName,
    RoleChecker = true,
    // formName,
    mode = 1,
    DepartmentHandler,
    linkColumnName,
    linkColumnValue,
    allElementsData = [],
  } = props;

  const {
    elementName,
    elementValue,
    elementId,
    elementType,
    enableByDefault,
    readOnly,
    isActive,
    validation,
    isMandatory,
    options,
    isMultiple,
  } = elementDetails || {};

  const { commonStore, userStore, metaDataStore } = useStore();
  const { MarkloginDepartmentData, markloginUserNameData } = userStore;
  const { originalLTOs, cloneLTOs} = metaDataStore
  const componentRef = useRef<any>(null);
  // const [, setCard] = useState<string>('');
  const [, setDropDownOptionsTwo] = useState<string>('');
  const [dropDownNFAIhandler, setDropDownNFAIhandler] = useState(false);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (markloginUserNameData.length !== 1) {
        setDropDownOptionsTwo(elementDetails.elementValue || '');
      } else {
        setDropDownOptionsTwo(markloginUserNameData?.[0]?.value || '');
      }
    }, 100);
  
    return () => {
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line
  }, [setDropDownOptionsTwo]);

  // Calculate file upload indices and total count dynamically
  const fileUploadMetadata = useMemo(() => {
    let uploadCount = 0;
    let currentUploadIndex = -1;
    
    // Count all AddFiles elements
    const totalAddFiles = allElementsData.filter((el: any) => el.elementType === 'AddFiles').length;
    
    // Find current element's position among AddFiles elements
    allElementsData.forEach((el: any, idx: number) => {
      if (el.elementType === 'AddFiles') {
        if (el.elementId === elementDetails?.elementId) {
          currentUploadIndex = uploadCount;
        }
        uploadCount++;
      }
    });
    
    return {
      fileUploadIndex: currentUploadIndex >= 0 ? currentUploadIndex : 0,
      totalFileUploads: totalAddFiles,
      allElementsData
    };
  }, [elementDetails?.elementId, allElementsData]);

  const classNameFunc = (data: boolean, className: string) => {
    if (data === true) {
      return `enable-workflow-element ${className}`;
    }
    return `disable-workflow-element ${className}`;
  };

  const optionList = (optData: any) => {
    // eslint-disable-next-line
    optData?.sort(function (
      a: { optionIndex: number },
      b: { optionIndex: number },
    ) {
      return a.optionIndex - b.optionIndex;
    });
    return optData?.map((data: any) => ({
      key: data.optionId,
      text: data.optionName,
      value: data.optionName,
    }));
  };

  const dropdownOptionHandler = (optData: string | string[]) => {
    const valuesArray = Array.isArray(optData) ? optData : optData.split('|');
    return valuesArray.map((value) => ({
      key: value.trim(),
      text: value.trim(),
      value: value.trim(),
    }));
  };

  const selectedOption = (value: string) => {
    if(userStore.user?.customerName === 'PCPLCRM'){
      if (Array.isArray(value) || value === '') {
        return value;
    }
     else if (typeof value === 'string') {
        return value.split('|');
    } else {
        return [];
        // Or handle the case where value is neither a string nor an array
    }
    }
    else{
      const arrDuplicates = value?.split('|');
      return arrDuplicates?.[0]?.length ? arrDuplicates : [];
    }
  };

  const masterUserOption = (value: string) => {
    const arrDuplicates = value?.split('|');
    let x = arrDuplicates[1]?.length ? arrDuplicates[1].split(',') : [];
    return x;
  };

  // useEffect(() => {
  //   if (
  //     DynamicDashboardStore.staticSelectedCard ||
  //     commonStore.staticDemoChanges ||
  //     commonStore.markLoginStaticRegisterDemoChages
  //   ) {
  //     setCard(DynamicDashboardStore.staticSelectedCard);
  //   }
  //   // eslint-disable-next-line
  // }, [DynamicDashboardStore.staticSelectedCard]);

  return (
    <React.Fragment>
      {elementName && (
        <>
          {
            // parent
            enableByDefault &&
              isActive &&
              elementType === 'Parent' &&
              mode !== 2 && (
                <Grid.Row
                  className={
                    elementType?.toUpperCase() === 'PARENT'
                      ? 'parentMetaDataAndWorkflowHeaders'
                      : ''
                  }
                >
                  <Grid.Column
                    width={16}
                    className={
                      RoleChecker
                        ? readOnly || !isActive || disabled
                          ? 'elementReadonly'
                          : ''
                        : readOnly || !isActive
                          ? 'elementReadonly'
                          : ''
                    }
                  >   
                    <h4 style={userStore.user?.customerName === 'PCPLCRM' ? {fontSize: '20px',color:'#2185d0'} :{color: '#333 !important'}}>{elementName}</h4>
                  </Grid.Column>
                </Grid.Row>
              )
          }
          {enableByDefault &&
            isActive &&
            elementType === 'DateTime' &&
            mode !== 2 && (
              <Grid.Column
                width={16}
                style={!!(disabled && RoleChecker) ? { display: 'flex' } : {}}
              >
                {!!(disabled && RoleChecker) && (
                  <Icon
                    style={{
                      bottom: '-0.5px',
                      left: '1px',
                      position: 'relative',
                    }}
                    name="lock"
                    color="grey"
                  />
                )}
                <label
                  className={
                    mode === 0 || elementName === linkColumnName
                      ? 'component-isDisabled'
                      : ''
                  }
                  style={{
                    color: 'black',
                    marginBottom: '.28571429rem',
                    display: 'inline-block',
                  }}
                >
                  {elementName}
                </label>
                <DatePicker
                  dateFormat="MMMM d, yyyy h:mmaa"
                  showTimeSelect
                  showMonthDropdown
                  showYearDropdown
                  id={elementId}
                  value={
                    elementName === linkColumnName && linkColumnValue
                      ? linkColumnValue
                      : elementValue
                        ? elementValue
                        : moment().toDate().toDateString()
                  }
                  selected={
                    elementValue !== ''
                      ? new Date(elementValue)
                      : moment().toDate()
                  }
                  closeOnScroll={(e) => e.target === document}
                  className={
                    mode === 0 || elementName === linkColumnName
                      ? 'date-picker-style component-isDisabled'
                      : 'date-picker-style'
                  }
                  onChange={(data) => {
                    onChangeHandler('', data, elementDetails);
                  }}
                  popperProps={{ strategy: 'fixed' }}
                  disabled={mode === 0 || elementName === linkColumnName}
                />
              </Grid.Column>
            )}
          {enableByDefault &&
            isActive &&
            elementType === 'Checkbox' &&
            mode !== 2 && (
            <Grid.Column
                width={16}
                style={!!(disabled && RoleChecker) ? { display: 'flex' } : {}}
                >
                {!!(disabled && RoleChecker) && (
                <Icon
                    style={{
                      bottom: '-0.5px',
                      left: '1px',
                      position: 'relative',

                    }}
                    name="lock"
                    color="grey"
                  />
                )}
                <label
                  className={mode === 0 ? 'component-isDisabled' : ''}
                  style={{
                    color: 'black',
                    marginBottom: '.28571429rem',
                    // display: 'inline-block',

                  }}
                >
                  {elementName}
              </label>
              <div style={{ marginTop: '6px' }}>
              <Checkbox
                    checked={elementValue === 'true'}
                    onChange={(e, data) =>
                      onChangeHandler(
                        e,
                        { value: `${data.checked}` },
                        elementDetails,
                      )
                    }
                    label={elementName}
                    disabled={mode === 0}
                  />
                </div>
                </Grid.Column>)}
          {enableByDefault &&
            isActive &&
            elementType.split('|')?.[0] === 'CurrentUser' &&
            mode !== 2 && (
              <Grid.Column
                width={16}
                style={!!(disabled && RoleChecker) ? { display: 'flex' } : {}}
              >
                {!!(disabled && RoleChecker) && (
                  <Icon
                    style={{
                      bottom: '-0.5px',
                      left: '1px',
                      position: 'relative',
                    }}
                    name="lock"
                    color="grey"
                  />
                )}
                <Form.Field
                  style={
                    !!(disabled && RoleChecker)
                      ? {
                          width: '200px',
                          marginTop: '5px',
                        }
                      : { marginTop: '5px' }
                  }
                  id={elementId}
                  label={elementName}
                  control={Input}
                  placeholder={elementName}
                  required={isMandatory}
                  readOnly
                  name={elementName}
                  // value={
                  //   elementName === linkColumnName && linkColumnValue
                  //     ? linkColumnValue
                  //     : elementValue !== ''
                  //     ? elementValue
                  //     : userStore.user?.displayName
                  // }
                  value={
                    elementValue
                      ? elementValue
                      : elementType.split('|')?.[1] ===
                          'displayNameWithTimeStamp'
                        ? `By ${userStore?.user?.displayName} on ${new Date()}`
                        : elementType.split('|')?.[1] === 'timeStamp'
                          ? new Date().toString()
                          : userStore?.user?.[
                              elementType.split(
                                '|',
                              )?.[1] as string as keyof GetCurrentUser
                            ]
                  }
                  disabled
                  // disabled={mode === 0 || elementName === linkColumnName}
                />
                {/* <a
                  className="confirm-user"
                  onClick={() => onConfirmUser(elementDetails)}
                >
                  {elementValue !== '' ? 'Confirmed' : 'Confirm User'}
                </a> */}
              </Grid.Column>
            )}
          {
            // masters
            enableByDefault &&
              isActive &&
              elementType === 'Masters' &&
              mode !== 2 && (
                <Grid.Column
                  width={16}
                  style={!!(disabled && RoleChecker) ? { display: 'flex' } : {}}
                >
                  {!!(disabled && RoleChecker) && (
                    <Icon
                      style={{
                        bottom: '-0.5px',
                        left: '1px',
                        position: 'relative',
                      }}
                      name="lock"
                      color="grey"
                    />
                  )}
                  <Form.Field
                    style={
                      !!(disabled && RoleChecker)
                        ? {
                            width: '200px',
                            marginTop: '5px',
                          }
                        : { marginTop: '5px' }
                    }
                    id={elementId}
                    label={elementName}
                    control={Select}
                    placeholder={elementName}
                    required={isMandatory}
                    name={elementName}
                    multiple={isMultiple}
                    clearable
                    fluid
                    disabled={
                      (RoleChecker ? readOnly || disabled : readOnly) ||
                      mode === 0 ||
                      elementName === linkColumnName
                    }
                    fluent="true"
                    search
                    selection
                    options={masterOptions}
                    // value={elementValue?.split('|')?.[1] || ''}
                    value={
                      elementName === linkColumnName && linkColumnValue
                        ? linkColumnValue
                        : isMultiple
                          ? masterUserOption(elementValue)
                          : elementValue?.split('|')?.[1]
                    }
                    error={errorMessage?.[`${elementId}`] || null}
                    onChange={mastersHandler}
                  />
                </Grid.Column>
              )
          }
          {
            // Users
            enableByDefault &&
              isActive &&
              elementType === 'Users' &&
              mode !== 2 && (
                <Grid.Column
                  width={16}
                  style={!!(disabled && RoleChecker) ? { display: 'flex' } : {}}
                >
                  {!!(disabled && RoleChecker) && (
                    <Icon
                      style={{
                        bottom: '-0.5px',
                        left: '1px',
                        position: 'relative',
                      }}
                      name="lock"
                      color="grey"
                    />
                  )}
                  <Form.Field
                    style={
                      !!(disabled && RoleChecker)
                        ? {
                            width: '200px',
                            marginTop: '5px',
                          }
                        : { marginTop: '5px' }
                    }
                    id={elementId}
                    label={elementName}
                    control={Select}
                    placeholder={elementName}
                    name={elementName}
                    multiple={isMultiple}
                    disabled={
                      readOnly ||
                      !isActive ||
                      (disabled && RoleChecker) ||
                      mode === 0 ||
                      elementName === linkColumnName
                    }
                    required={isMandatory}
                    clearable
                    fluid
                    fluent="true"
                    search
                    selection
                    options={usersOptions}
                    value={
                      elementName === linkColumnName && linkColumnValue
                        ? linkColumnValue
                        : isMultiple
                          ? masterUserOption(elementValue)
                          : elementValue?.split('|')?.[1]
                    }
                    error={errorMessage?.[`${elementId}`] || null}
                    onChange={usersHandler}
                  />
                </Grid.Column>
              )
          }
          {enableByDefault &&
            isActive &&
            elementType === 'DatePicker' &&
            mode !== 2 && (
              <Grid.Column
                width={16}
                className={
                  readOnly || !isActive || (disabled && RoleChecker)
                    ? 'elementReadonly'
                    : ''
                }
              >
                {!!(disabled && RoleChecker) && (
                  <Icon
                    style={{
                      bottom: '-0.5px',
                      left: '1px',
                      position: 'relative',
                    }}
                    name="lock"
                    color="grey"
                  />
                )}
                <label
                  className={
                    mode === 0 || elementName === linkColumnName
                      ? 'datepicker-mandatory component-isDisabled'
                      : 'datepicker-mandatory'
                  }
                  style={{ color: 'black' }}
                >
                  {elementName}
                </label>
                <DatePicker
                  showMonthDropdown
                  showYearDropdown
                  id={elementId}
                  value={
                    elementName === linkColumnName && linkColumnValue
                      ? linkColumnValue
                      : elementValue?.length
                        ? elementValue
                        : new Date().toLocaleDateString('en-IN', {
                            month: '2-digit',
                            day: '2-digit',
                            year: 'numeric',
                          })
                  }
                  selected={
                    elementValue?.length
                      ? new Date(
                          `${elementValue.split('/')?.[1]}/${elementValue.split(
                            '/',
                          )?.[0]}/${elementValue.split('/')?.[2]}`,
                        )
                      : new Date()
                  }
                  closeOnScroll={(e) => e.target === document}
                  // dateFormatCalendar="dd-yy-mmmm"
                  className={
                    mode === 0 || elementName === linkColumnName
                      ? 'date-picker-style component-isDisabled'
                      : 'date-picker-style'
                  }
                  // scrollableYearDropdown
                  onChange={(e: any, data: any) =>
                    onChangeHandler(e, data, elementDetails)
                  }
                  // popperProps={{ strategy: 'fixed' }}
                  disabled={mode === 0 || elementName === linkColumnName}
                  minDate={commonStore.staticDemoChanges ? new Date() : null}
                />
              </Grid.Column>
            )}
          {enableByDefault &&
            isActive &&
            elementType === 'DropDown' &&
            mode !== 2 && (
              <Grid.Row style={
                subTaskName === "DPX QC Report" ||  subTaskName === "DSM QC Report" 
                  ? { gridColumn: '1 / -1' }
                  : undefined
              }>
              <Grid.Column
                width={16}
                style={!!(disabled && RoleChecker) ? { display: 'flex' } : {}}
              >
                {!!(disabled && RoleChecker) && (
                  <Icon
                    style={{
                      bottom: '-0.5px',
                      left: '1px',
                      position: 'relative',
                    }}
                    name="lock"
                    color="grey"
                  />
                )}
                <Form.Field
                  style={
                    !!(disabled && RoleChecker)
                      ? {
                          width: '200px',
                          marginTop: '5px',
                        }
                      : { marginTop: '5px' }
                  }
                  id={elementId}
                  // upward={card !== "Request" ? true : false}
                  label={elementName}
                  control={Select}
                  disabled={
                    readOnly ||
                    (disabled && RoleChecker) ||
                    mode === 0 ||
                    elementName === linkColumnName
                  }
                  className={readOnly ? 'elementReadonly' : ''}
                  required={isMandatory}
                  placeholder={'select value'}
                  name={elementName}
                  clearable
                  fluid
                  fluent="true"
                  search
                  multiple={isMultiple}
                  selection
                  options={
                    elementName.includes('Select Department Select User')
                      ? markloginUserNameData
                      : elementName === 'ORIGINAL LTO'
                      ? dropdownOptionHandler(originalLTOs)
                      : elementName === 'CLONE LTO'
                      ? dropdownOptionHandler(cloneLTOs)
                      : !dropDownNFAIhandler && elementValue?.replace('|', '')
                        ? dropdownOptionHandler(elementValue)
                        : optionList(options)
                  }
                  onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
                    if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
                      e.stopPropagation();
                  }}
                  value={
                    elementName === linkColumnName && linkColumnValue
                      ? linkColumnValue
                      : isMultiple
                        ? selectedOption(elementValue)
                        : elementValue?.replace('|', '')
                  }
                  onClick={() => {
                    setDropDownNFAIhandler(true);
                  }}
                  error={errorMessage?.[`${elementId}`] || null}
                  onChange={(e: any, data: any) => {
                    onChangeHandler(e, data, elementDetails);
                  }}
                />
              </Grid.Column></Grid.Row>
            )}
          {enableByDefault &&
            isActive &&
            elementType === 'DynamicTable' &&
            mode !== 2 && (
              <Grid.Row style={{ gridColumn: '1 / -1',overflowX:'auto' }}>
                <Grid.Column width={16}>
                  {!elementDetails ? (
                    <LoadingComponent />
                  ) : (
                    <DynamicRowsComponent
                      options={options}
                      saveDynamicTableData={saveDynamicTableData}
                      elementDetails={elementDetails}
                      readOnly={readOnly}
                      isMandatory={isMandatory}
                      error={errorMessage?.[`${elementId}`] || null}
                      subTaskIdNo={subTaskIdNo || ''}
                      mode={mode} subTaskName={subTaskName || ''}  />
                  )}
                </Grid.Column>
              </Grid.Row>
            )}
          {enableByDefault &&
            isActive &&
            elementType === 'link' &&
            mode !== 2 && (
              <Grid.Column
                width={16}
                style={!!(disabled && RoleChecker) ? { display: 'flex' } : {}}
              >
                <label>{elementName}</label>
                {!!(disabled && RoleChecker) && (
                  <Icon
                    style={{
                      bottom: '-0.5px',
                      left: '1px',
                      position: 'relative',
                    }}
                    name="lock"
                    color="grey"
                  />
                )}
                <div className="external-link">
                  <Link to={{ pathname: elementValue }} target="_blank">
                    {elementName}
                  </Link>
                </div>
              </Grid.Column>
            )}
          {enableByDefault &&
            isActive &&
            elementType === 'metadataFromParent' &&
            mode !== 2 && (
              <Grid.Column
                width={16}
                style={!!(disabled && RoleChecker) ? { display: 'flex' } : {}}
              >
                {!!(disabled && RoleChecker) && (
                  <Icon
                    style={{
                      bottom: '-0.5px',
                      left: '1px',
                      position: 'relative',
                    }}
                    name="lock"
                    color="grey"
                  />
                )}
                <Form.Field
                  required={/mandatory/gi.test(validation) || isMandatory}
                  id={elementId}
                  control={Input}
                  value={elementValue}
                  name={elementName}
                  placeholder={elementName}
                  label={elementName}
                  disabled={
                    readOnly ||
                    (disabled && RoleChecker) ||
                    mode === 0 ||
                    elementName === linkColumnName
                  }
                  className={
                    mode === 0 || elementName === linkColumnName
                      ? 'component-isDisabled'
                      : ''
                  }
                  onChange={(e: any, data: any) =>
                    onChangeHandler(e, data, elementDetails)
                  }
                  error={errorMessage?.[`${elementId}`]}
                />
              </Grid.Column>
            )}
          {enableByDefault &&
            isActive &&
            elementType === 'TextBox' &&
            mode !== 2 && (
              <Grid.Column
                width={16}
                style={disabled && RoleChecker ? { display: 'flex' } : {}}
              >
                {disabled && RoleChecker && (
                  <Icon
                    style={{
                      bottom: '-0.5px',
                      left: '1px',
                      position: 'relative',
                    }}
                    name="lock"
                    color="grey"
                  />
                )}
                <Form.Field
                  required={/mandatory/gi.test(validation) || isMandatory}
                  id={elementId}
                  control={Input}
                  // className={classNameFunc(enableByDefault, "asset-list-page-input")}
                  value={
                    elementName === linkColumnName && linkColumnValue
                      ? linkColumnValue
                      : elementValue
                  }
                  name={elementName}
                  placeholder={elementName}
                  label={elementName}
                  disabled={
                    readOnly ||
                    (disabled && RoleChecker) ||
                    mode === 0 ||
                    elementName === linkColumnName
                  }
                  className={
                    mode === 0 || elementName === linkColumnName
                      ? 'component-isDisabled'
                      : ''
                  }
                  onChange={(e: any, data: any) =>
                    onChangeHandler(e, data, elementDetails)
                  }
                  onBlur={unfocusHandler}
                  error={errorMessage?.[elementId]}
                />
              </Grid.Column>
            )}
          {enableByDefault &&
            elementType === 'Department' &&
            mode !== 2 &&
            commonStore.markLoginStaticRegisterDemoChages && (
              <Grid.Column
                width={16}
                style={!!(disabled && RoleChecker) ? { display: 'flex' } : {}}
              >
                {!!(disabled && RoleChecker) && (
                  <Icon
                    style={{
                      bottom: '-0.5px',
                      left: '1px',
                      position: 'relative',
                    }}
                    name="lock"
                    color="grey"
                  />
                )}
                <Form.Field
                  style={
                    !!(disabled && RoleChecker)
                      ? {
                          width: '200px',
                          marginTop: '5px',
                        }
                      : { marginTop: '5px' }
                  }
                  id={elementId}
                  label={elementName}
                  control={Select}
                  placeholder={elementName}
                  required={isMandatory}
                  name={elementName}
                  multiple={isMultiple}
                  clearable
                  fluid
                  disabled={
                    (RoleChecker ? readOnly || disabled : readOnly) ||
                    mode === 0 ||
                    elementName === linkColumnName
                  }
                  fluent="true"
                  search
                  selection
                  options={MarkloginDepartmentData}
                  // value={elementValue?.split('|')?.[1] || ''}
                  value={
                    // for 8080 changes
                    // isMultiple ? masterUserOption(elementValue) : elementValue
                    elementName === linkColumnName && linkColumnValue
                      ? linkColumnValue
                      : !isMultiple
                        ? masterUserOption(elementValue)
                        : elementValue
                  }
                  error={errorMessage?.[`${elementId}`] || null}
                  onChange={DepartmentHandler}
                />
              </Grid.Column>
            )}
          {enableByDefault &&
            isActive &&
            elementType === 'AddPhotograph' &&
            mode !== 2 && (
              <Grid.Row
                className={
                  readOnly || (disabled && RoleChecker) || mode === 0
                    ? 'elementReadonly'
                    : ''
                }
              >
                <Grid.Column width={16} style={{ gridColumn: '1 / -1' }}>
                  <PhotoUpload
                    elem={elementDetails}
                    onPhotoClick={onPhotoClick}
                    index={index}
                    isMandatory={isMandatory}
                    errorMessage={errorMessage?.[`${elementId}`] || ''}
                    disabled={disabled}
                    RoleChecker={RoleChecker}
                  />
                </Grid.Column>
              </Grid.Row>
            )}
          {enableByDefault &&
          isActive &&
          elementType === 'AddFiles' &&
          mode !== 2 &&
          elementName ? (
            <Grid.Row
              style={{ gridColumn: '1 / -1' }}
              className={
                readOnly || (disabled && RoleChecker) || mode === 0
                  ? 'elementReadonly'
                  : ''
              }
            >
              <Grid.Column
                width={16}
                style={!!disabled ? { display: 'flex' } : {}}
              >
                {!!disabled && (
                  <Icon
                    style={{
                      bottom: '-0.5px',
                      left: '1px',
                      position: 'relative',
                    }}
                    name="lock"
                    color="grey"
                  />
                )}
                <FileUpload
                  elementName={elementName}
                  filesUploaded={elementDetails}
                  getUploadedFiles={getUploadedFiles}
                  index={index}
                  isMandatory={isMandatory}
                  errorMessage={errorMessage?.[`${elementId}`] || ''}
                  fileUploadIndex={fileUploadMetadata.fileUploadIndex}
                  totalFileUploads={fileUploadMetadata.totalFileUploads}
                  allElementsData={fileUploadMetadata.allElementsData}
                />
              </Grid.Column>
            </Grid.Row>
          ) : null}
          {enableByDefault &&
            isActive &&
            !!elementValue?.length &&
            mode !== 2 &&
            elementType === 'Barcode' && (
              <Grid.Column>
                <div ref={componentRef}>
                  <img
                    alt="Barcode Generator TEC-IT"
                    className="barcode-img"
                    src={
                      'https://barcode.tec-it.com/barcode.ashx?data=' +
                      elementValue?.split('|')[0] +
                      '&code=' +
                      elementValue?.split('|')[1]
                    }
                  />
                </div>
                <ReactToPrint
                  trigger={() => (
                    <Button variant="contained" color="teal">
                      Print
                    </Button>
                  )}
                  content={() => componentRef.current}
                />
              </Grid.Column>
            )}
          {enableByDefault &&
          isActive &&
          elementType === 'Barcode' &&
          mode !== 2 &&
          elementValue === null ? (
            <Grid.Column>
              <Message>
                <Message.Header>No barcode data found</Message.Header>
              </Message>
            </Grid.Column>
          ) : null}
          {enableByDefault &&
            (elementType === 'TextArea' || elementType.includes('ScanArea')) &&
            mode !== 2 &&
            isActive &&
            elementName && (
              <Grid.Column
                width={16}
                style={
                  !!(disabled && RoleChecker)
                    ? { display: 'flex' } 
                    : { gridColumn: '1 / -1' }
                }
              >
                {!!(disabled && RoleChecker) && (
                  <>
                    <Icon
                      style={{
                        bottom: '-0.5px',
                        left: '1px',
                        position: 'relative',
                      }}
                      name="lock"
                      color="grey"
                    />
                  </>
                )}
                {elementType.includes('ScanArea') && (
                  <Icon name="barcode" size="large" />
                )}
                <label
                  style={
                     userStore.user?.customerName  === 'PCPLCRM'? 
                    { fontSize: '17px',  fontWeight: 'bold' } : {
                    display: 'inline',
                    opacity:
                      readOnly || (disabled && RoleChecker) || mode === 0
                        ? 0.45
                        : 1,
                  }}
                  className={(userStore.user?.customerName  === 'PCPLCRM' && readOnly) ? 'component-isDisabled' : ''}
                >
                  {elementName}
                </label>
                {isMandatory && <span style={{ color: '#db2828' }}>*</span>}
                <Form.Field
                  control={TextArea}
                  id={elementId}
                  required={isMandatory}
                  disabled={readOnly || (disabled && RoleChecker) || mode === 0}
                  placeholder={elementName}
                  name={elementName}
                  // label={elementName}
                  value={
                    elementName === linkColumnName && linkColumnValue
                      ? linkColumnValue
                      : elementValue
                  }
                  // label={elementName}
                  className={
                    mode === 0 || elementName === linkColumnName
                      ? 'component-isDisabled'
                      : classNameFunc(enableByDefault, '')
                  }
                  onChange={(e: any, data: any) =>
                    onChangeHandler(e, data, elementDetails)
                  }
                  error={errorMessage?.[`${elementId}`] || null}
                  style={{
                    border:
                      elementType.includes('ScanArea') &&
                      elementType.split('|')?.[1] !== 'Neutral'
                        ? elementType.split('|')?.[1] === 'Red'
                          ? '2px solid red'
                          : '2px solid lightgreen'
                        : '1px solid rgba(34,36,38,.15)',
                  }}
                />
              </Grid.Column>
            )}
        </>
      )}
    </React.Fragment>
  );
}

export default Components;
